import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  forwardButton: {
    right: 5,
    position: "absolute",
  },
  backButton: {
    left: 5,
    position: "absolute",
  },
  icon: {
    padding: 5,
    top: "calc(50% - 15px)",
    position: "absolute",
    backgroundColor: theme.palette.basic.white,
    "&:hover": {
      "@media (hover: hover) and (pointer: fine)": {
        backgroundColor: theme.palette.basic.white,
        opacity: "1 !important",
      },
    },
    opacity: 0,
  },
}));

export default useStyles;
